import React from 'react';

import { Lock } from 'lucide-react';

interface ConsentLockProps {
    isConsentLocked: boolean;
    openConsentDataGather: () => void;
}
export const ConsentLock = (props: ConsentLockProps): JSX.Element | null => {
    const { isConsentLocked, openConsentDataGather } = props;

    if (!isConsentLocked) return null;

    return (
        <div className='mbts_analysis__consent_lock'>
            <p className='text-semibold text-lg'>Want to unlock full report?</p>
            <button className='btn btn--sm btn--radius-sm btn--primary' onClick={openConsentDataGather}>
                <Lock />
                <span>Unlock Report</span>
            </button>
        </div>
    );
};